module.exports = __webpack_public_path__ + "img/Banner-GroupOfSchoolChildren-dwnszd.4a73cef7.jpg";